import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { ChartBackGroundColors } from "../ChartColors";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
          position: "top", // Changed to top/bottom since 'left' might crowd a stacked bar chart
          display: true    // Turned on so users can see which color represents which status
        },
    },
    scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true,
        },
      },
};

function DocumentBarChart({ documentTypeMatrix }) {
    // Edge case: handle empty array safely to prevent runtime errors
    if (!documentTypeMatrix || documentTypeMatrix.length === 0) {
        return <div>No data available</div>;
    }

    let dataLabels = [];
    let datasets = [];
    
    // Dynamically grab all possible status labels from the first item
    let groupLabels = documentTypeMatrix[0].statuses.map(documentStatus => documentStatus.statusLabel);

    // --- Fixed Section ---
    documentTypeMatrix.forEach((doc) => {
        dataLabels.push(doc.typeLabel);
    });

    groupLabels.forEach((label, i) => {
        datasets.push({
            label: label,
            data: documentTypeMatrix.map(doc => {
                const statusObj = doc.statuses.find(status => status.statusLabel === label);
                return statusObj ? statusObj.count : 0;
            }),
            backgroundColor: ChartBackGroundColors[i] || 'rgba(128, 128, 128, 0.5)',
        });
    });
    // ---------------------

    const data = {
        labels: dataLabels,
        datasets: datasets
    };

    return (
      <div style={{ height: "400px" }}> {/* Added wrapper since maintainAspectRatio is false */}
          <Bar options={options} data={data} />
      </div>
    );
}

export default DocumentBarChart;